import * as RadixTooltip from '@radix-ui/react-tooltip';
import type { ReactNode } from 'react';

/**
 * Підказка для кнопок без підпису.
 *
 * Атрибут `title`, яким це робилось раніше, не показується з клавіатури, не
 * зʼявляється на дотику й малюється операційною системою — тобто виглядає
 * чужим і працює лише мишею.
 */
export function TooltipProvider({ children }: { children: ReactNode }): ReactNode {
	return (
		<RadixTooltip.Provider delayDuration={300} skipDelayDuration={200}>
			{children}
		</RadixTooltip.Provider>
	);
}

export function Tooltip({ label, children }: { label: string; children: ReactNode }): ReactNode {
	return (
		<RadixTooltip.Root>
			<RadixTooltip.Trigger asChild>{children}</RadixTooltip.Trigger>
			<RadixTooltip.Portal>
				<RadixTooltip.Content
					sideOffset={6}
					className="z-50 rounded-md border border-border bg-surface px-2 py-1 text-xs text-fg shadow-e2"
				>
					{label}
					<RadixTooltip.Arrow className="fill-surface" />
				</RadixTooltip.Content>
			</RadixTooltip.Portal>
		</RadixTooltip.Root>
	);
}
